import { DevicePlatform, EnrollmentStatus, ModGeneration, Role } from '../enums';

export enum LicenseCategory {
    MOD = 'MOD',
    FOD = 'FOD',
}

export enum LicenseType {
    LIFETIME = 'LIFETIME',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ENDING_SOON = 'ENDING_SOON',
    EXPIRED = 'EXPIRED',
}

export enum LicenseOrigin {
    CAR_NET_SHOP = 'CAR_NET_SHOP',
    VDBS = 'VDBS',
}

export type Contract = {
    articleId: string | null;
    activationDate: string | null;
    available: boolean;
    category: LicenseCategory;
    description: string | null;
    expirationDate: string | null;
    name: string;
    origin: LicenseOrigin;
    licenseType: LicenseType;
    masterSalesPartNumber: string | null;
    lifetimeLicense: boolean;
    isSubscriptionLicense: boolean | null;
};

export type VehicleOverview = {
    vin: string;
    nickname: string;
    licensePlateNumber: string | null;
    role: Role;
    enrollmentStatus: EnrollmentStatus;
    devicePlatform: DevicePlatform;
    primaryCar: boolean;
    cubicNetworkEnabled: boolean;
    carDetails: string | null;
    contracts: Contract[] | null;
    contractsRequestFailed: boolean;
    modGeneration: ModGeneration;
};

export type ContractsOverview = {
    vehicleOverviews: VehicleOverview[];
    cubicNetworkEnabled: boolean;
};